package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.Administrador
import kotlinx.browser.window

@Composable
fun GestionGabineteScreen(viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    val esAdminGeneral = uiState.rolAdmin?.rol == "GENERAL"
    val tituloPantalla = if (esAdminGeneral) "Supervisión de Gabinete: ${uiState.selectedComunaGabineteNombre}" else "Gestión de mi Gabinete"

    Div({
        style {
            padding(20.px)
            fontFamily("sans-serif")
            backgroundColor(Color("#1976D2"))
            minHeight(100.vh)
        }
    }) {
        Div({
            style {
                backgroundColor(Color.white)
                padding(24.px)
                borderRadius(12.px)
                maxWidth(1000.px)
                property("margin", "0 auto")
                property("box-shadow", "0 4px 12px rgba(0,0,0,0.1)")
            }
        }) {
            // Cabecera
            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.SpaceBetween)
                    alignItems(AlignItems.Center)
                    marginBottom(24.px)
                    property("border-bottom", "2px solid #1976D2")
                    paddingBottom(16.px)
                }
            }) {
                H2({ style { margin(0.px); color(Color("#1976D2")) } }) { Text(tituloPantalla) }
                
                Div({ style { display(DisplayStyle.Flex); gap(12.px) } }) {
                    if (!esAdminGeneral) {
                        Button(attrs = {
                            onClick { viewModel.onAgregarFuncionarioClicked() }
                            style {
                                padding(8.px, 16.px); backgroundColor(Color("#34A853"))
                                color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer"); fontWeight("bold")
                            }
                        }) { Text("➕ Añadir Funcionario") }
                    }

                    Button(attrs = {
                        onClick { onBack() }
                        style {
                            padding(8.px, 16.px); backgroundColor(Color("#6c757d"))
                            color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer")
                        }
                    }) { Text("Cerrar") }
                }
            }

            if (uiState.isLoading) {
                P { Text("Cargando gabinete...") }
            } else {
                Table({
                    style { width(100.percent); property("border-collapse", "collapse") }
                }) {
                    Thead {
                        Tr {
                            Th({ style { padding(12.px); textAlign("left"); property("border-bottom", "2px solid #EEE") } }) { Text("Funcionario") }
                            Th({ style { padding(12.px); textAlign("left"); property("border-bottom", "2px solid #EEE") } }) { Text("Email de Acceso") }
                            Th({ style { padding(12.px); textAlign("left"); property("border-bottom", "2px solid #EEE") } }) { Text("Rol / Cargo") }
                            Th({ style { padding(12.px); textAlign("center"); property("border-bottom", "2px solid #EEE") } }) { Text("Estado") }
                            if (!esAdminGeneral) {
                                Th({ style { padding(12.px); textAlign("center"); property("border-bottom", "2px solid #EEE") } }) { Text("Acción") }
                            }
                        }
                    }
                    Tbody {
                        uiState.gabineteAdmins.forEach { admin ->
                            Tr {
                                Td({ style { padding(12.px); property("border-bottom", "1px solid #EEE") } }) { 
                                    Div {
                                        B { Text(admin.nombre ?: "N/A") }
                                        if (admin.nombre?.contains("@") == false && admin.nombre != admin.rol) {
                                            // Si ya tiene nombre real, lo mostramos destacado
                                            P({ style { fontSize(11.px); margin(0.px); color(Color.gray) } }) { Text("Cargo: ${admin.rol}") }
                                        }
                                    }
                                }
                                Td({ style { padding(12.px); property("border-bottom", "1px solid #EEE") } }) { Text(admin.email ?: "N/A") }
                                Td({ style { padding(12.px); property("border-bottom", "1px solid #EEE"); textAlign("center") } }) {
                                    // --- 🛡️ INTERRUPTOR DE ACTIVIDAD ---
                                    val activo = admin.estaActivo
                                    Button(attrs = {
                                        onClick { viewModel.onCambiarEstadoAdmin(admin, !activo) }
                                        style {
                                            padding(4.px, 12.px); borderRadius(20.px); cursor("pointer")
                                            backgroundColor(if (activo) Color("#48BB78") else Color("#F56565"))
                                            color(Color.white); fontWeight("bold"); fontSize(10.px); border(0.px)
                                        }
                                    }) { Text(if (activo) "ON" else "OFF") }
                                }
                                Td({ style { padding(12.px); property("border-bottom", "1px solid #EEE"); textAlign("center") } }) {
                                    val uid = admin.uidAuth
                                    val docId = admin.tokenFCM // Aquí viene el ID del documento
                                    val rolFuncionario = admin.rol
                                    
                                    // 🛡️ REGLA DE DETECCIÓN SANKAN: Es temporal si el ID del documento es igual al uidAuth
                                    val idEsTemporal = uid == docId || uid.contains("_") || uid == admin.email
                                    
                                    Div({ style { display(DisplayStyle.Flex); gap(4.px); justifyContent(JustifyContent.Center) } }) {
                                        if (idEsTemporal) {
                                            // Botón Activar (Disponible para ambos si el perfil es nuevo)
                                            Button(attrs = {
                                                onClick { viewModel.onActivarAccesoClicked(admin) }
                                                style {
                                                    padding(6.px, 10.px); backgroundColor(Color("#34A853"))
                                                    color(Color.white); border(0.px); borderRadius(4.px); cursor("pointer")
                                                    fontSize(10.px); fontWeight("bold")
                                                }
                                            }) { Text("🚀 ACTIVAR") }
                                        } else {
                                            // --- ⚖️ REGLAS DE SOBERANÍA ---
                                            // El General solo edita al Comunal. El Comunal edita a todos menos a sí mismo.
                                            val puedeEditar = (esAdminGeneral && rolFuncionario == "COMUNAL") || (!esAdminGeneral && rolFuncionario != "COMUNAL")

                                            if (puedeEditar) {
                                                // Botón Editar Persona
                                                Button(attrs = {
                                                    onClick { 
                                                        val currentName = admin.nombre ?: ""
                                                        val nombreActual = currentName.split("(").first().trim()
                                                        val nuevoNombre = window.prompt("Nombre del Funcionario Responsable:", nombreActual)
                                                        if (!nuevoNombre.isNullOrBlank()) {
                                                            val rutActual = if (currentName.contains("RUT:")) {
                                                                currentName.split("RUT:").last().replace(")", "").trim()
                                                            } else ""
                                                            val nuevoRut = window.prompt("RUT del Funcionario (ej: 12.345.678-9):", rutActual)
                                                            if (!nuevoRut.isNullOrBlank()) {
                                                                viewModel.onActualizarNombreAdmin(admin, "$nuevoNombre (RUT: $nuevoRut)")
                                                            }
                                                        }
                                                    }
                                                    style {
                                                        padding(6.px, 10.px); backgroundColor(Color("#FFA000"))
                                                        color(Color.white); border(0.px); borderRadius(4.px); cursor("pointer")
                                                        fontSize(10.px)
                                                    }
                                                }) { Text("📝") }

                                                // Botón Reset Clave
                                                Button(attrs = {
                                                    onClick { viewModel.onResetClaveClicked(admin) }
                                                    style {
                                                        padding(6.px, 10.px); backgroundColor(Color("#1976D2"))
                                                        color(Color.white); border(0.px); borderRadius(4.px); cursor("pointer")
                                                        fontSize(10.px)
                                                    }
                                                }) { Text("🔑") }
                                                
                                                // Botón Eliminar
                                                Button(attrs = {
                                                    onClick { viewModel.onEliminarAdminClicked(admin) }
                                                    style {
                                                        padding(6.px, 10.px); backgroundColor(Color("#D32F2F"))
                                                        color(Color.white); border(0.px); borderRadius(4.px); cursor("pointer")
                                                        fontSize(10.px)
                                                    }
                                                }) { Text("🗑️") }
                                            } else {
                                                // Vista de solo lectura para el General sobre cargos menores
                                                Span({ style { fontSize(10.px); color(Color.gray); fontStyle("italic") } }) { 
                                                    Text(if (esAdminGeneral) "Supervisión" else "Auto-Gestionado") 
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (uiState.gabineteAdmins.isEmpty()) {
                    P({ style { textAlign("center"); padding(24.px); color(Color.gray) } }) {
                        Text("No se han sembrado credenciales para este territorio aún.")
                    }
                }
            }

            // Nota informativa
            Div({
                style {
                    marginTop(24.px); padding(16.px); backgroundColor(Color("#E3F2FD"))
                    borderRadius(8.px); property("border-left", "4px solid #1976D2")
                }
            }) {
                P({ style { fontSize(13.px); margin(0.px); color(Color("#1565C0")) } }) {
                    Text("Nota Informativa: Estas credenciales permiten el acceso a los distintos niveles de mando de la comuna. El Administrador Comunal es responsable de activar y entregar estos accesos a su equipo.")
                }
            }
        }
    }
}
